import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const POPOVER_ARROW_ICON_WIDTH = 29;
export const PopoverArrowIcon = (props)=>/*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: POPOVER_ARROW_ICON_WIDTH,
        height: "9",
        viewBox: "0 0 ".concat(POPOVER_ARROW_ICON_WIDTH, " 9"),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M13.0858 7.98904L7.3284 2.96713C5.5174 1.38745 3.0612 0.499999 0.5 0.499999L28.5 0.5C25.9388 0.5 23.4826 1.38745 21.6716 2.96712L15.9142 7.98904C15.1332 8.67032 13.8668 8.67032 13.0858 7.98904Z",
            fill: "currentColor"
        })
    }));
